<template>
  <div class="table-page-search-wrapper" id="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48" class="searchRow">
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input :class="[searchModel.assetNumber ? 'heightLight' : '']" :disabled="true" placeholder="资产编号" v-model="searchModel.assetNumber"/>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input :class="[searchModel.txt50 ? 'heightLight' : '']" :disabled="true" placeholder="资产描述" v-model="searchModel.txt50" />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input :class="[searchModel.ndjar ? 'heightLight' : '']" :disabled="true" placeholder="资产使用年限" v-model="searchModel.ndjar" />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColSelect">
            <a-select
              :class="[searchModel.assetConstructionStatus ? 'heightLight' : '']"
              :disabled="true"
              :allowClear="true"
              v-model="searchModel.assetConstructionStatus"
              showSearch
              placeholder="资产状态"
              @change="search('search')"
            >
              <a-select-option v-for="(item, index) in assetTypeList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-range-picker
              :class="[searchModel.aktivDate ? 'heightLightDate' : '']"
              :disabled="true"
              :showToday="false"
              :placeholder="['资本化日期开始', '资本化日期结束']"
              v-model="searchModel.aktivDate"
              style="width: 100%"
            />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-range-picker
              :class="[searchModel.zugdtDate ? 'heightLightDate' : '']"
              :disabled="true"
              :showToday="false"
              :placeholder="['首次购置日期开始', '首次购置日期结束']"
              v-model="searchModel.zugdtDate"
              style="width: 100%"
            />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-range-picker
              :class="[searchModel.deaktDate ? 'heightLightDate' : '']"
              :disabled="true"
              :showToday="false"
              :placeholder="['不活动日期开始', '不活动日期结束']"
              v-model="searchModel.deaktDate"
              style="width: 100%"
            />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-select
              :class="[searchModel.ord42 ? 'heightLight' : '']"
              :disabled="true"
              :allowClear="true"
              v-model="searchModel.ord42"
              showSearch
              placeholder="增加方式"
            >
              <a-select-option v-for="(item, index) in addTypeList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColSelect">
            <a-input :class="[searchModel.menge ? 'heightLight' : '']" :disabled="true" placeholder="资产数量" v-model="searchModel.menge" />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColSelect">
            <a-select
              :class="[searchModel.ord41 ? 'heightLight' : '']"
              :disabled="true"
              :allowClear="true"
              v-model="searchModel.ord41"
              showSearch
              placeholder="使用状态"
            >
              <a-select-option v-for="(item, index) in useTypeList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input :class="[searchModel.raumn ? 'heightLight' : '']" :disabled="true" placeholder="责任人" v-model="searchModel.raumn" />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input :class="[searchModel.ebeln ? 'heightLight' : '']" :disabled="true" placeholder="采购关联订单" v-model="searchModel.ebeln" />
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-input-group compact style="width: 100%">
              <a-input :class="[searchModel.kansw ? 'heightLight' : '']" :disabled="true" v-model="searchModel.kansw" type="number" style=" width: calc(50% - 15px); text-align: center" placeholder="购置价值(元)" />
              <a-input
                style=" width: 30px; border-left: 0; pointer-events: none"
                placeholder="~"
                disabled
              />
              <a-input :class="[searchModel.kanswEnd ? 'heightLight' : '']" :disabled="true" v-model="searchModel.kanswEnd" type="number" style="width: calc(50% - 15px); text-align: center; border-left: 0" placeholder="购置价值(元)" />
            </a-input-group>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColSelect">
            <a-input-group compact style="width: 100%">
              <a-input :class="[searchModel.qmjz ? 'heightLight' : '']" :disabled="true" v-model="searchModel.qmjz" type="number" style=" width: calc(50% - 15px); text-align: center" placeholder="现值" />
              <a-input
                style=" width: 30px; border-left: none; pointer-events: none"
                placeholder="~"
                disabled
              />
              <a-input :class="[searchModel.qmjzEnd ? 'heightLight' : '']" :disabled="true" v-model="searchModel.qmjzEnd" type="number" style="width: calc(50% - 15px); text-align: center; border-left: 0" placeholder="现值" />
            </a-input-group>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-tree-select
              :class="[searchModel.useDeptIdTab ? 'heightLight' : '']"
              :disabled="true"
              v-model="searchModel.useDeptIdTab"
              style="width: 100%"
              placeholder="使用部门"
              allow-clear
              show-search
              treeNodeFilterProp="title"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :treeData="useDepartmentsList"
              :replaceFields="{
                title: 'url',
                key: 'key',
                value: 'key'
              }"
            ></a-tree-select>
          </a-col>
          <a-col :md="6" :sm="24" class="searchColInput">
            <a-select
              :class="[searchModel.relevantDeptId ? 'heightLight' : '']"
              :disabled="true"
              :allowClear="true"
              v-model="searchModel.relevantDeptId"
              showSearch
              optionFilterProp="label"
              placeholder="归口部门"
            >
              <a-select-option v-for="(item, index) in focalDepartmentsList" :value="item.deptId" :label="item.departmentname" :key="index">
                {{ item.departmentname }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import processIcon from '@/views/assetLedger/modules/processIcon'
import {
  assetTypeList,
  getfocalDepartmentsList,
  getSelectDataList, getSyncAsset,
  getTreeByRoleUsedeptList
} from '@/api/assetLedger'
import processDropDown from '@/components/ProcessDropDown/ProcessDropDown'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'SearchForm',
  props: ['searchModel'],
  components: {
    processDropDown,
    processIcon
  },
  computed: {
    ...mapGetters(['assetCompanyId']),
  },
  watch: {
    assetCompanyId (newValue) {
      console.log(newValue)
      if (newValue.id !== '') {
        if (newValue.id === '空') {
          this.useDepartmentsList = []
        } else {
          this.companyId = newValue.id
        }
      } else {
        this.companyId = null
      }
      if (newValue.id !== '空') {
        this.getUseDepartmentsList()
      }
    }
  },
  data () {
    return {
      showExpend: false,
      popoverStyle: {
        mixWidth: '0px',
        width: '100px'
      },
      processList: ['资产盘点', '领用申请', '调拨申请', '归还申请', '报废申请', '维修申请'],
      advanced: false, // 是否展开
      // 资产状态下拉列表
      assetTypeList: [
        {
          code: 1,
          name: '资产新建'
        },
        {
          code: 2,
          name: '在建工程-在建'
        },
        {
          code: 3,
          name: '在建工程-已拨交'
        },
        {
          code: 4,
          name: '常规资产-在用'
        },
        {
          code: 5,
          name: '常规资产-已处置'
        }
      ],
      // 增加方式
      addTypeList: [],
      // 使用方式
      useTypeList: [],
      // 使用方式
      useDepartmentsList: [],
      // 归口部门
      focalDepartmentsList: [],
      roleList: [],
      // 是否显示发起流程
      visible: false,
      // 同步按钮的loading
      synchronizationLoading: false,
      companyId: null
    }
  },
  created () {
    if (this.searchModel.zugdt && this.searchModel.zugdtEnd) {
      this.searchModel.zugdtDate = [moment(this.searchModel.zugdt), moment(this.searchModel.zugdtEnd)]
    }
    if (this.searchModel.aktiv && this.searchModel.aktivEnd) {
      this.searchModel.aktivDate = [moment(this.searchModel.aktiv), moment(this.searchModel.aktivEnd)]
    }
    if (this.searchModel.deakt && this.searchModel.deaktEnd) {
      this.searchModel.deaktDate = [moment(this.searchModel.deakt), moment(this.searchModel.deaktEnd)]
    }
    // 获取增加方式，使用状态下拉数据
    this.getSelectDataList()
    // 获取归口部门下拉数据
    this.getFocalDepartmentsList()
    this.getUseDepartmentsList()
  },
  mounted () {
  },
  methods: {
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = self.resetTheChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取使用部门
    getUseDepartmentsList () {
      const data = {
        paging: false,
        companyId: this.assetCompanyId.id
      }
      getTreeByRoleUsedeptList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.useDepartmentsList = res.data
        }
      })
    },
    // 搜索使用部门
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 获取增加方式，使用状态下拉数据
    getSelectDataList () {
      getSelectDataList().then(res => {
        if (res.status === 0) {
          this.addTypeList = res.data.tjfsList
          this.useTypeList = res.data.syztList
        }
      })
    },
    // 获取归口部门下拉数据
    getFocalDepartmentsList () {
      getfocalDepartmentsList().then(res => {
        if (res.status === 0) {
          this.focalDepartmentsList = res.data
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
}
.unfold{
  height: 126px;
  //margin-bottom: 10px;
}
.searchRow {
  margin: 0 !important;
  .ant-calendar-picker {
    width: 100%;
  }
}
.searchColInput {
  padding: 0 12px 0 0 !important;
  margin-bottom: 12px;
}
.searchColSelect {
  padding: 0 12px 0 0 !important;
  margin-bottom: 12px;
}
.searchColBtn {
  padding: 0 !important;
  .table-page-search-submitButtons {
    margin-bottom: 10px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.btn {
  padding: 0 10px !important;
}
.btnMarginLeft_12 {
  margin-left: 10px !important;
}
.unfoldText {
  color: #1791FF;
  position: relative;
  cursor: pointer;
  width: 48px;
  display: inline-block;
}
.unfoldIcon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 3px;
  right: 4px;
  margin: auto;
  color: #1791FF;
  font-size: 12px;
  line-height: 1;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
/deep/.ant-popover-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  a {
    line-height: 15px;
  }
  .marignBottom_12 {
    margin-bottom: 12px;
  }
}
.btnLoading {
  padding: 0 10px 0 29px !important;
}
/deep/.ant-input-disabled {
  color: #b7b7b7 !important;
}
/deep/.ant-select .ant-select-arrow {
  color: #b7b7b7 !important;
}
.heightLight {
  color: #1791FF !important;
}
.heightLightDate{
  /deep/span {
    color: #1791FF !important;
  }
}
</style>
